import { Stack, Text } from '@mantine/core';

import { ProceedingValidationAction } from '@/module/Author/Proceeding/Validation/ProceedingValidationAction';
import { ProceedingValidationHistory } from '@/module/Author/Proceeding/Validation/ProceedingValidationHistory';
import { ProceedingDeleteButton } from '@/module/Author/Proceeding/components/ProceedingDeleteButton';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, BdiList, PublicationPages, PublisherLink } from '@feature/utils';
import { ConferenceLink } from '@feature/utils/components/ConferenceLink';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { ProceedingProofAction } from './Proof';
import { Proceeding } from './model/ProceedingTypes';

interface ProceedingViewProps {
  proceeding: Proceeding;
}

export function ProceedingView({ proceeding }: ProceedingViewProps) {
  const {
    authors,
    noOfPages,
    publisher,
    startPage,
    endPage,
    conference,
    bookName,
    publisherType,
    bdis,
    universityAffiliatedNoOfAuthors,
    noOfRoAuthors,
  } = proceeding;

  return (
    <Stack>
      <PublicationContent
        publication={proceeding}
        authorsNo={authors.length}
        editAction={
          <EditButtonLink
            size="xs"
            miw="100px"
          />
        }
        deleteAction={<ProceedingDeleteButton proceedingId={proceeding.id} />}
      />
      <ViewCitationsButton
        entityId={proceeding.id}
        entityType="PROCEEDING"
      />
      <Content type="full">
        <Stack gap="xs">
          {publisher && (
            <PublisherLink
              publisherId={publisher.id}
              title={publisher.title}
            />
          )}
          {publisherType && <Text>Tip editura: {publisherType.name}</Text>}
          {conference && (
            <ConferenceLink
              conferenceId={conference.id}
              title={conference.conferenceName}
            />
          )}
          {bookName && <Text>{bookName}</Text>}
          <PublicationPages
            noOfPages={noOfPages ?? 0}
            endPage={endPage ?? 0}
            startPage={startPage ?? 0}
          />
          <BdiList bdis={bdis} />
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList
          authors={authors}
          affiliatedNo={universityAffiliatedNoOfAuthors}
          noOfRoAuthors={noOfRoAuthors}
        />
      </Content>
      <ProceedingProofAction
        proceedingId={proceeding.id}
        authors={authors}
      />
      <ProceedingValidationAction proceedingId={proceeding.id} />
      <ProceedingValidationHistory proceedingId={proceeding.id} />
    </Stack>
  );
}
